import { wrapString } from 'tabview/blocks/misc/string';
import type { WrapLabel } from './toLeafText';

/** How a rectangle breaks a label: at spaces, and inside a word too long for the line. */
export const hyphenateWrap: WrapLabel = ({
  text,
  availableWidth,
  measure,
  maxLines,
}) => wrapString(text, availableWidth, measure, maxLines);
